'use es6';

import { Children, isValidElement } from 'react';

// src/index.ts
function getValidChildren(children) {
  return Children.toArray(children).filter(child => /*#__PURE__*/isValidElement(child));
}
export { getValidChildren };